<template>
  <button class="center button is-info" @click="this.clickFunction">
    {{ this.text }}
  </button>
</template>

<script>
export default {
  name: "Button",
  props: ["text", "clickFunction"],
};
</script>

<style scoped>
button.center {
  /* display: block; */
  /* margin: 10px auto; */
  /* margin-bottom: 40px; */
}
</style>
